module.exports = __webpack_public_path__ + "img/fig10.50bc72d2.jpg";